import React, { FC } from 'react';

import { SearchFiltersCategory } from './categories/SearchFiltersCategory';
import { SearchFilterBarItem } from './SearchFilterBarItem';

import {
  reportFilterToggle,
  filterActionTypes,
} from '../mobile-actions/filtersUtils';

import {
  Connect,
  PropsFromRedux,
} from './SearchFiltersBarPreparatoryWorkContainer';

type Props = PropsFromRedux;

const RawSearchFiltersBarPreparatoryWork: FC<Props> = ({
  type,
  shouldDisplayCategory,
  hasCategorySelected,
  categoryCount,
  shouldDisplayLegislativeFolder,
  hasLegislativeFolderSelected,
  legislativeFolderCount,
}) => {
  const track = (actionType: filterActionTypes, value: boolean) =>
    reportFilterToggle(type, actionType, value);

  return (
    <>
      {shouldDisplayLegislativeFolder && (
        <SearchFilterBarItem>
          <SearchFiltersCategory
            count={legislativeFolderCount}
            type="pwLegislativeFolder"
            isSelected={hasLegislativeFolderSelected}
            track={track}
            searchType="preparatory_work"
          />
        </SearchFilterBarItem>
      )}
      {shouldDisplayCategory && (
        <SearchFilterBarItem>
          <SearchFiltersCategory
            count={categoryCount}
            type="pwCategory"
            isSelected={hasCategorySelected}
            track={track}
            searchType="preparatory_work"
          />
        </SearchFilterBarItem>
      )}
    </>
  );
};

export const SearchFiltersBarPreparatoryWork = Connect(
  RawSearchFiltersBarPreparatoryWork,
);
